import React from 'react';

export default function BearEarsSvg({ size = 40, className = '' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" className={className}>
      <polygon points="14.33,24.81 2.0,19.7 7.11,7.37 19.44,12.47" fill="#724E3C" />
      <polygon points="37.68,19.7 25.34,24.81 20.23,12.47 32.57,7.37" fill="#724E3C" />
      <polygon points="35.86,17.01 29.69,19.56 25.86,10.31 32.03,7.76" fill="#724E3C" />
      <polygon points="29.69,19.56 35.86,17.01 34.86,16.51 28.69,19.06" fill="#2F2018" opacity="0.95" />
      <polygon points="29.69,19.56 28.69,19.06 24.86,9.81 25.86,10.31" fill="#2F2018" opacity="0.95" />
      <polygon points="11.99,19.56 5.82,17.01 9.65,7.76 15.82,10.31" fill="#724E3C" />
      <polygon points="5.82,17.01 11.99,19.56 10.99,19.06 4.82,16.51" fill="#2F2018" opacity="0.95" />
      <polygon points="5.82,17.01 4.82,16.51 8.65,7.26 9.65,7.76" fill="#2F2018" opacity="0.95" />
      <polygon points="34.66,22.73 7.97,22.73 7.97,19.4 34.66,19.4" fill="#724E3C" />
      <polygon points="7.97,22.73 34.66,22.73 32.66,21.73 5.96,21.73" fill="#2F2018" opacity="0.95" />
      <polygon points="7.97,22.73 5.96,21.73 5.96,18.39 7.97,19.4" fill="#2F2018" opacity="0.95" />
      <polygon points="38.0,32.74 34.66,32.74 34.66,19.4 38.0,19.4" fill="#724E3C" />
      <polygon points="34.66,32.74 38.0,32.74 36.0,31.74 32.66,31.74" fill="#2F2018" opacity="0.95" />
      <polygon points="34.66,32.74 32.66,31.74 32.66,18.39 34.66,19.4" fill="#2F2018" opacity="0.95" />
      <polygon points="7.97,32.74 4.63,32.74 4.63,19.4 7.97,19.4" fill="#724E3C" />
      <polygon points="4.63,32.74 7.97,32.74 5.96,31.74 2.63,31.74" fill="#2F2018" opacity="0.95" />
      <polygon points="4.63,32.74 2.63,31.74 2.63,18.39 4.63,19.4" fill="#2F2018" opacity="0.95" />
    </svg>
  );
}
